import { checkStgUrl } from '../../../utils/bookingUtils';

export default {
    items: [
        {
            value: 'A',
            path: '/booking/pr/photo',
            headText: 'Photo Booking',
            description: '',
            icon: 'picture',
            color: '#4C6793',
            roleView: [true, false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
        {
            value: 'B',
            path: '/booking/pr/video',
            headText: 'Video Booking',
            description: '',
            icon: 'video-camera',
            color: '#9c9efe',
            roleView: [true, false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
        {
            value: 'C',
            path: '/booking/pr/design',
            headText: 'Design Booking',
            description: '',
            icon: 'file-ppt',
            color: 'purple',
            roleView: [false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
        {
            value: 'D',
            path: '/booking/pr/printing',
            headText: 'Printing Booking',
            description: '',
            icon: 'printer',
            color: '#68B984',
            roleView: [false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
    ]
}
